module.exports = __webpack_public_path__ + "static/media/sms-respond-correct.24b8b27d.png";